import PageMeta from "../components/PageMeta";
import { ContactCTA } from "../components/SiteShell";
import { properties } from "../content";
export default function Portfolio() {
  return (
    <>
      <PageMeta
        title="Our communities | Owners First"
        description="Explore a selection of the Melbourne properties and communities cared for by Owners First."
      />
      <section className="site-wrap site-page-intro">
        <h1>
          Places with
          <br />
          <span>people at heart.</span>
        </h1>
        <div>
          <p>
            Every building has its own character. Every community has its own
            needs. Here are a few of the places we’re proud to look after.
          </p>
        </div>
      </section>
      <section
        className="site-wrap site-portfolio-section"
        aria-label="Our managed communities"
      >
        <div className="site-portfolio-grid">
          {properties.map((property) => (
            <article
              id={property.id}
              key={property.id}
              className="site-portfolio-item"
            >
              <div className="site-portfolio-photo">
                <img
                  src={property.image}
                  alt={`${property.name} building in ${property.area}`}
                  loading="lazy"
                  width="600"
                  height="750"
                />
              </div>
              <div className="site-portfolio-name">
                <h2>{property.name}</h2>
                <p>{property.area}</p>
              </div>
              <p className="site-portfolio-description">
                {property.description}
              </p>
            </article>
          ))}
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
